import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { SectionsCard } from '@/features/site/SectionsCard'
import { SponsorsCard } from '@/features/site/SponsorsCard'
import { PageHeader } from '@/ui'

/**
 * The public marketing site, as far as this panel is concerned: which sections it shows, in what
 * order, and who its sponsors are. Everything here is gated on `site.manage`.
 */
export const Route = createFileRoute('/_authed/site')({
  component: SitePage,
})

function SitePage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t('site.title')} description={t('site.description')} />
      <SectionsCard />
      <SponsorsCard />
    </div>
  )
}
